<template>
  <div class="button" @click="onClick">
    <a class="text">
      {{ $t('community.removeUserFromCommunity.removeMember') }}
    </a>
  </div>
</template>
<script>
export default {
  name: 'RemoveUserFromCommunity',
  props: {
    communityId: {
      type: String,
      required: true
    },
    userId: {
      type: String,
      required: true
    }
  },
  methods: {
    onClick() {
      this.$store.dispatch('removeMember', { communityId: this.communityId, userId: this.userId })
    }
  }
}
</script>
<style scoped lang="scss">
.button {
  padding: 4px 6px;
  width: 100%;
  height: 100%;

  .text {
    height: 40px;
  }

  &:hover {
    background-color: $primary-color;
    color: white;
  }
}

</style>
